module.exports = __webpack_public_path__ + "static/media/message.6ee34c5d.svg";